import { ChatConversationContent, type ChatContentProps } from './chat-conversation-content';
import { useNovaChatContentOptions } from '../contexts/nova-chat-content-options-context';

/** Conversation content uses the persistent shell's renderers and preview providers. */
export function NovaChatConversation(props: ChatContentProps) {
  const options = useNovaChatContentOptions();
  return <ChatConversationContent {...options} {...props} />;
}
